export default __webpack_public_path__ + "static/media/databricks.5af29275.png";